import type {
  AspOriginalData,
  AspRequest,
  Pagination,
  RequestSubtitles,
  Subtitles,
  VideoContent
} from '@/models/interface/funTv';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class FunTvService extends ApiFactory {
  constructor() {
    super('FunTV');
  }

  /** 抓取上課影片及news, music, tube影片 */
  getMediaIds(data: Pick<Pagination, 'page' | 'size'>): Promise<ApiDataResponse<VideoContent>> {
    return super.post('GetMediaIds', data);
  }

  /** 抓取字幕 */
  getMediaSubtitle(data: RequestSubtitles): Promise<ApiDataResponse<Subtitles[]>> {
    return super.post('GetMediaSubtitle', data);
  }

  /** 抓取文章（先用舊的FunTV的api 因為新版文章分類與原始不同） */
  async getResources(data: string): Promise<AspOriginalData> {
    return fetch(`https://funday.asia/api/enradio/playrandom.asp?list=${data}`)
      .then((res) => res.json())
      .catch((error) => console.log(error));
  }

  /** 新版api */
  async getResourcesV2(data: AspRequest): Promise<AspOriginalData> {
    return fetch(`https://funday.asia/api/EnRadio/PlayrandomV3.asp`,{
      method: 'POST',
      body: JSON.stringify(data)
    })
      .then((res) => res.json())
      .catch((error) => console.log(error));
  }
}
